/*
 Copyright (C) COMPOFFICE-R Kft, RentIT - All Rights Reserved
 Unauthorized copying of this file, via any medium is strictly prohibited
 Proprietary and confidential

 */
RCA.client.ChangePass = (function () {
    function Init() {
        var $header = $('#changepass-details .data-label');
        $header.text(RCA.shared.Language.getItem('profile-change-pass'));
    }

    $(document).on('submit', '#changepass-details #formChangePass', function (e) {
        e.preventDefault();
        $.post('api/', {
            do: 'changePassword',
            data: RCA.shared.serializeObject($(this))
        }, function (data) {
            if (data.status === "ok") {
                RCA.client.Modal.alert(RCA.shared.Language.getItem(data.message), function(){
                    RCA.client.Layout.hide("changepass-details");
                });

            } else {
                RCA.client.Modal.alert(RCA.shared.Language.getItem(data.message));
            }
        });
    });

    $(document).on('click', '#changepass-details .showpass', function(e) {
        e.target.previousElementSibling.type = "text";
        setTimeout(function () {
            e.target.previousElementSibling.type = "password";
        }, 2000);
    });

    return {
        Init: Init
    };
})();
